import React from 'react'
import { Translation } from 'react-i18next'
// import AddEmailContainer from '../../../containers/employer/lightEntrepreneurs/addEmail.container'
import ExpandablePanel from '../../../utils/expandablePanel'
import SortableTableLightEntrepreneur from '../../../utils/employer/sortableTableLightEntrepreneur'

const FavoriteLightEntrepreneursComponent = ({
  lightEntre,
  handleLightEntrepreneurPreview,
  setFavouriteEntrepreneurs
}) => {
  return (
    <Translation>
      {() => {
        return (
          <div className="container">
            {/* <div className="row">
              <AddEmailContainer />
            </div> */}
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title="Favorite light entrepreneurs"
                    renderBody={() =>
                      createLightEntrepreneurTable(
                        lightEntre,
                        leHeaderCells,
                        handleLightEntrepreneurPreview,
                        setFavouriteEntrepreneurs
                      )
                    }
                    defaultExpanded={true}
                    employerSide={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const createLightEntrepreneurTable = (
  lightEntre,
  leHeaderCells,
  handleLightEntrepreneurPreview,
  setFavouriteEntrepreneurs
) => (
  <SortableTableLightEntrepreneur
    data={lightEntre}
    headerCells={leHeaderCells}
    enableFilters={true}
    handleLightEntrepreneurPreview={handleLightEntrepreneurPreview}
    setFavouriteEntrepreneurs={setFavouriteEntrepreneurs}
  />
)

const leHeaderCells = [
  {
    id: 'firstname',
    label: 'employer.lightEntrepreneurs.columnFirstname',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile',
    filter: {
      type: 'string'
    }
  },
  {
    id: 'lastname',
    label: 'employer.lightEntrepreneurs.columnLastname',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile',
    filter: {
      type: 'string'
    }
  },
  {
    id: 'email',
    label: 'employer.lightEntrepreneurs.column2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    }
  }
]

export default FavoriteLightEntrepreneursComponent
